

<template>
  <section class="relative z-0 bg-cover bg-center text-white text-center pt-40 pb-20 px-4">
    <h1 class="text-3xl md:text-5xl font-extrabold mb-4">SEU CARRINHO</h1>
  </section>
</template>
